import { Button } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";
import { useLabelsStore } from "../../stores/index.js";

/** Multi-select label picker. Labels are cross-cutting tags a task can carry
 *  several of (distinct from the nested Topic grouping). Lives under the form's
 *  Advanced options. */
export function LabelField({ value, onChange }: { value: string[]; onChange: (ids: string[]) => void }) {
  const { t } = useI18n();
  const labels = useLabelsStore((s) => s.labels);

  function toggle(id: string) {
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  }

  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-muted-foreground">{t("taskForm.labels")}</p>
      {labels.length === 0 ? (
        <p className="text-xs text-muted-foreground">{t("taskForm.noLabels")}</p>
      ) : (
        <div className="flex flex-wrap items-center gap-1.5">
          {labels.map((label) => (
            <Button
              key={label.id}
              type="button"
              size="sm"
              variant={value.includes(label.id) ? "primary" : "outline"}
              onClick={() => toggle(label.id)}
              className="gap-1.5"
            >
              <span
                className="h-2.5 w-2.5 rounded-full border"
                style={{ background: label.color ?? "transparent" }}
              />
              {label.name}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
